import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "@/components/Logo";

const Footer = () => (
  <footer className="border-t border-white/10 bg-surface/60" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-12">
      <div className="md:col-span-5">
        <Logo />
        <p className="mt-5 text-sm text-gray-400 leading-relaxed max-w-sm">
          An American performance marketing firm engineering high-ROAS acquisition systems on Meta and
          Google. A Wyoming limited liability company — US registered, internationally focused.
        </p>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-flame mb-5">Navigate</p>
        <ul className="space-y-3 text-sm">
          <li><Link className="text-gray-300 hover:text-white transition-colors" to="/" data-testid="footer-link-home">Home</Link></li>
          <li><Link className="text-gray-300 hover:text-white transition-colors" to="/services/meta-ads" data-testid="footer-link-meta-ads">Meta Ads</Link></li>
          <li><Link className="text-gray-300 hover:text-white transition-colors" to="/services/google-ads" data-testid="footer-link-google-ads">Google Ads</Link></li>
          <li><Link className="text-gray-300 hover:text-white transition-colors" to="/contact" data-testid="footer-link-contact">Contact</Link></li>
        </ul>
      </div>
      <div className="md:col-span-4">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-flame mb-5">Contact</p>
        <ul className="space-y-4 text-sm">
          <li>
            <a href="tel:+13075007253" data-testid="footer-phone-link" className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors">
              <Phone className="h-4 w-4 text-flame" />+1 (307) 500-7253
            </a>
          </li>
          <li>
            <a href="mailto:contact@viberagroup.com" data-testid="footer-email-link" className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors">
              <Mail className="h-4 w-4 text-flame" />contact@viberagroup.com
            </a>
          </li>
          <li className="flex items-center gap-3 text-gray-400">
            <MapPin className="h-4 w-4 text-flame" />Wyoming, United States
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-gray-500">
        <p>© {new Date().getFullYear()} Vibera Group LLC. All rights reserved.</p>
        <p>Meta and Google are trademarks of their respective owners.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
